module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c8c4a50da40b5cc2c646815412a601e.png";